<div class="upload__row">
  <ng-container
    *ngFor="let additionalDocument of cachedAdditionalDocuments; index as index"
  >
    <div class="form__field">
      <div class="label">
        <mat-label
          >{{ "User.Document.AdditionalDocument" | translate }}
          {{ index + 1 }}</mat-label
        >
      </div>
      <favie-upload-file
        [label]="defaultImportInfo.label | translate"
        [iconUrl]="defaultImportInfo.iconUrl"
        [path]="storagePath"
        [file]="additionalDocument.file"
        [isDisabled]="isDisabled"
        (fileChange)="updateAdditionalDocuments($event, index)"
      >
      </favie-upload-file>
    </div>
  </ng-container>
</div>
